import React, { useState } from "react";
import CustomScroll from "react-custom-scroll";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Preloader from "../../Preloader";
import { SupportedDocumentTypeService } from "oasis-document-viewer";
import CoreConsts from "../../../constants/CoreConsts";
import ServiceUrls from "../../../constants/ServiceUrls";
import FileService from "../../../services/DocumentStore/FileService";

import { insertSearchItemToBridge } from "../../../services/DocumentStore/MiscellaneousService";
import TRCardView from "./CardView";
import NoResult from "../NoResult";
const { DOCUMENTSTORE_SERVICE_URL } = ServiceUrls;

const {
  getPhysicalFiles,
  getPhysicalFileToken,
  downloadResultsForPhysicalSearch,
  downloadPhysicalFilePreviewStream,
} = FileService;
const {
  SUPPORTED_IMAGE_FILE_TYPES,
  SUPPORTED_MS_OFFICE_FILE_TYPES,
  SUPPORTED_PDF_FILE_TYPES,
  SUPPORTED_PREVIEW_FILE_TYPES,
  matchContentTypes,
} = CoreConsts;

const supportedDocumentTypeService = new SupportedDocumentTypeService({
  SUPPORTED_PDF_FILE_TYPES,
  SUPPORTED_MS_OFFICE_FILE_TYPES,
  SUPPORTED_IMAGE_FILE_TYPES,
  SUPPORTED_PREVIEW_FILE_TYPES,
});

export default ({
  searchResponse,
  physicalSearchParams,
  searchText,
  updateStateAndPhysicalSearch,
  updateParentState,
  user,
  isTriggeredSearch,
  _,
}) => {
  const [IsDownloadOpen, setIsDownloadOpen] = useState(false);
  const [OpenSortList, setOpenSortList] = useState(false);
  const [isLoading, setisLoading] = useState(false);

  const { orderByItem, filters, selectedItemIds } = physicalSearchParams;
  const { sortFields } = filters;
  const { trItems, totalCount } = searchResponse;

  const updateSelectedItems = (itemId, checked) => {
    let newState = [];
    if (checked) {
      newState = [...physicalSearchParams.selectedItemIds, itemId];
    } else {
      newState = physicalSearchParams.selectedItemIds.filter(
        (f) => f !== itemId
      );
    }
    updateParentState({
      physicalSearchParams: {
        ...physicalSearchParams,
        selectedItemIds: [...newState],
      },
    });
  };

  const downloadResults = (type) => {
    setisLoading(true);
    const { pageSize, pageNumber, filters, ...rest } = physicalSearchParams;
    downloadResultsForPhysicalSearch({
      ...filters,
      ...rest,
      fileType: type,
      searchText,
    }).then((blob) => {
      const link = document.createElement("a");
      link.setAttribute("href", window.URL.createObjectURL(blob));
      link.setAttribute("download", "TRResults.csv");
      link.click();
      setisLoading(false);
    });
  };

  const viewInBridge = (ids) => {
    const host = window.location.hostname;
    let bridgeApp = "https://testbridge.oasisgroup.com/dhsrmweb";

    if (host === "clienthub.oasisgroup.com" || host === "hub.omnidox5.com") {
      bridgeApp = "https://oasisbridge.oasisgroup.com/dhsrmweb";
    }

    insertSearchItemToBridge(ids).then(() => {
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        `${bridgeApp}/index.html?${user["user-email"]}`
      );
      link.target = "_blank";
      link.click();
    });
  };

  const canPreviewDocument = (documentMetadatas) =>
    supportedDocumentTypeService.canPreviewDocument(documentMetadatas);

  const viewDocument = async (doc) => {
    setisLoading(true);
    const itemId = doc.itemId;

    let Stream;
    let token;
    let contentType;
    switch (true) {
      case supportedDocumentTypeService.canInlinePreviewDocument(doc):
        Stream = await getPhysicalFiles({ itemId });

        break;
      case supportedDocumentTypeService.canUsePreviewService(doc):
        const { type, Stream: _Stream } =
          await downloadPhysicalFilePreviewStream(itemId);
        Stream = _Stream;
        contentType = type;
        break;
      default:
        token = await getPhysicalFileToken({ itemId });
        break;
    }
    const selectedDocument = {
      ...doc,
      token,
      "content-type": matchContentTypes[doc.fileMime],
      documentUrl: `${DOCUMENTSTORE_SERVICE_URL}api/File/GetPhysicalFileByLink/${token}`,
      Stream,
    };
    setisLoading(false);
    // if (Stream) {
    // auditDocumentView(
    //   documentIdentifier,
    //   documentMetadata["folder-id"],
    //   documentMetadata["document-type-id"]
    // );
    updateParentState({
      showModal: true,
      selectedDocument,
    });
    // } else {
    //   updateParentState({ NotificationMessage: "Document is not found" });
    // }
  };

  // const viewDocument = (itemId) => {
  //   setisLoading(true);
  //   getPhysicalFiles({ itemId }).then((stream) => {
  //     setisLoading(false);
  //     if (stream) {
  //       updateParentState({
  //         showModal: true,
  //         DocumentStream: stream,
  //       });
  //     } else {
  //       updateParentState({ NotificationMessage: "Document is not found" });
  //     }
  //   });
  // };

  const downloadDocument = (itemId, originalFileName) => {
    setisLoading(true);
    getPhysicalFiles({ itemId }).then((stream) => {
      const link = document.createElement("a");
      link.setAttribute("href", stream);
      link.setAttribute("download", originalFileName);
      link.click();
      setisLoading(false);
    });
  };

  return trItems && trItems.length > 0 ? (
    <>
      {isLoading && <Preloader />}
      <div className="result-options">
        {selectedItemIds.length > 0 && (
          <div
            className="view-in-bridge"
            onClick={() => {
              viewInBridge(selectedItemIds);
            }}
          >
            View in Bridge
          </div>
        )}
        <div className="align-self-end download-results">
          <Dropdown
            className="dropdown-toggle portlet-menu-button"
            isOpen={IsDownloadOpen}
            toggle={() => setIsDownloadOpen(!IsDownloadOpen)}
          >
            <DropdownToggle caret>
              <i className="icon-omni-download"></i>
              Download Results
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => downloadResults(0)}>
                Download CSV
              </DropdownItem>
              {/* <DropdownItem>Download Excel</DropdownItem>
                      <DropdownItem>Download PDF</DropdownItem> */}
            </DropdownMenu>
          </Dropdown>
        </div>
        <div className="sort-by download-results">
          <Dropdown
            className="dropdown-toggle portlet-menu-button"
            isOpen={OpenSortList}
            toggle={() => setOpenSortList(!OpenSortList)}
          >
            <DropdownToggle caret>Sort by</DropdownToggle>
            {sortFields && (
              <DropdownMenu>
                {sortFields.map((field, key) => (
                  <DropdownItem
                    key={key}
                    style={
                      orderByItem.orderBy === field.fieldName &&
                      orderByItem.typeIds === field.typeIds
                        ? { color: "#fd7e14" }
                        : {}
                    }
                    onClick={() => {
                      var newState = {
                        ...orderByItem,
                        orderBy: field.fieldName,
                        typeIds: field.typeIds,
                      };
                      updateStateAndPhysicalSearch({
                        orderByItem: newState,
                        pageNumber: 1,
                      });
                    }}
                  >
                    {field.fieldCaption}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            )}
          </Dropdown>
        </div>
        {orderByItem.orderType === "ASC" ? (
          <i
            className="icon-omni-down-arrow"
            onClick={() => {
              var newState = {
                ...orderByItem,
                orderType: "DESC",
              };
              updateStateAndPhysicalSearch({
                orderByItem: newState,
                pageNumber: 1,
              });
            }}
          ></i>
        ) : (
          <i
            className="icon-omni-up-arrow"
            onClick={() => {
              var newState = {
                ...orderByItem,
                orderType: "ASC",
              };
              updateStateAndPhysicalSearch({
                orderByItem: newState,
                pageNumber: 1,
              });
            }}
          ></i>
        )}
      </div>
      <CustomScroll
        heightRelativeToParent={"calc(100%)"}
        allowInnerScroll={true}
      >
        {trItems.map((item) => {
          const doc = {
            ...item,
            "content-type": matchContentTypes[item.fileMime],
          };
          return (
            <TRCardView
              key={item.itemId}
              item={doc}
              viewInBridge={viewInBridge}
              updateSelectedItems={updateSelectedItems}
              viewDocument={viewDocument}
              canPreviewDocument={canPreviewDocument}
              downloadDocument={downloadDocument}
            />
          );
        })}
        {trItems.length < totalCount && (
          <div className="d-flex mt-3 load-more-results justify-content-center ">
            <button
              className="d-flex justify-content-center styled-button "
              type="button"
              onClick={() =>
                updateStateAndPhysicalSearch({
                  pageNumber: physicalSearchParams.pageNumber + 1,
                })
              }
            >
              Load More Results
            </button>
          </div>
        )}
      </CustomScroll>
    </>
  ) : (
    <div className="no-data">
      {isTriggeredSearch ? _.ClientHub.NoDataResult : ""}
    </div>
  );
};
